@if (title()) {
    <div class="field-group-title" woa-activatable (onActivate)="onActivateTitle.emit()">
        {{ title() | translate: translationParams() }}
    </div>
}
<div class="field-group-body">
    <ng-content></ng-content>
</div>
